import Vue from 'vue'
import Router from 'vue-router'
// import WirelessHeadset from '@/views/WirelessHeadset'
// import WirelessHeadset from '@/views/productclass/WirelessHeadset'
// import HIFI from '@/views/productclass/HIFI'
// import Alone from '@/views/productclass/Alone'
// import Live from '@/views/productclass/Live'
// import Studio from '@/views/productclass/Studio'
// import Neptune from '@/views/productclass/Neptune'
// import LE from '@/views/productclass/LE'
// import Parts from '@/views/productclass/Parts'

import MixedCellSeries from '@/views/MixedCellSeries'

import MixedCellSeriesMore from '@/views/MixedCellSeriesMore'
import PurchaseFusion from '@/views/PurchaseFusion'
import PurchaseFusionBox from '@/views/PurchaseFusionBox'
import EnterPurchase from '@/views/EnterPurchase'
import LimitedVersion from '@/views/LimitedVersion'
import login from '@/views/login'
import test from '@/views/test'
import Design from '@/views/Design'
import OderCenter from '@/views/OderCenter'
import DesignColor from '@/views/DesignColor'
import DesignMake from '@/views/DesignMake'
import DesignMessage from '@/views/DesignMessage'
import DesignShare from '@/views/DesignShare'
import pay from '@/views/pay'

import DesignPurchase from '@/views/DesignPurchase'



Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'MixedCellSeries',
            component: MixedCellSeries
        },
        {
            path: '/MixedCellSeries',
            name: 'MixedCellSeries',
            component: MixedCellSeries
        },
       
        {
            path: '/MixedCellSeriesMore',
            name: 'MixedCellSeriesMore',
            component: MixedCellSeriesMore
        },
        // {
        //     path: '/WirelessHeadset',
        //     name: 'WirelessHeadset',
        //     component: WirelessHeadset
        // },
        // {
        //     path: '/HIFI',
        //     name: 'HIFI',
        //     component: HIFI
        // },
        // {
        //     path: '/Alone',
        //     name: 'Alone',
        //     component: Alone
        // },
        // {
        //     path: '/Live',
        //     name: 'Live',
        //     component: Live
        // },
        // {
        //     path: '/Studio',
        //     name: 'Studio',
        //     component: Studio
        // },
        // {
        //     path: '/Neptune',
        //     name: 'Neptune',
        //     component: Neptune
        // },
        // {
        //     path: '/LE',
        //     name: 'LE',
        //     component: LE
        // },
        // {
        //     path: '/Parts',
        //     name: 'Parts',
        //     component: Parts
        // },
        {
            path: '/PurchaseFusion',
            name: 'PurchaseFusion',
            component: PurchaseFusion
        },
        {
            path: '/PurchaseFusionBox',
            name: 'PurchaseFusionBox',
            component: PurchaseFusionBox
        },
        {
            path: '/EnterPurchase',
            name: 'EnterPurchase',
            component: EnterPurchase
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/OderCenter',
            name: 'OderCenter',
            component: OderCenter
        },
            	{
                    path: 'test',
                    name: 'test',
                    component: test
        },   	
        {
            path: '/Design',
            name: 'Design',
            component: Design
        },
        {
            path: '/DesignColor',
            name: 'DesignColor',
            component: DesignColor
        },
        {
            path: '/DesignMake',
            name: 'DesignMake',
            component: DesignMake
        },
        {
            path: '/DesignMessage',
            name: 'DesignMessage',
            component: DesignMessage
        },

        {
            path: '/DesignShare',
            name: 'DesignShare',
            component: DesignShare
        },
        {
            path: '/DesignPurchase',
            name: 'DesignPurchase',
            component: DesignPurchase
        },
        {
            path: '/pay',
            name: 'pay',
            component: pay
        },

        

    ],
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }

})




// WEBPACK FOOTER //
// ./src/router/index.js